
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderShippingGrid extends Serenity.EntityGrid<OrderShippingRow, any> {
        protected getColumnsKey() { return OrderShippingColumns.columnsKey; }
        protected getDialogType() { return OrderShippingDialog; }
        protected getIdProperty() { return OrderShippingRow.idProperty; }
        protected getInsertPermission() { return OrderShippingRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderShippingRow.localTextPrefix; }
        protected getService() { return OrderShippingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderShippingService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}